import { render, staticRenderFns } from "./CreateLayoutFolderModal.vue?vue&type=template&id=bad3b68c&scoped=true"
import script from "./CreateLayoutFolderModal.vue?vue&type=script&lang=js"
export * from "./CreateLayoutFolderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad3b68c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bad3b68c')) {
      api.createRecord('bad3b68c', component.options)
    } else {
      api.reload('bad3b68c', component.options)
    }
    module.hot.accept("./CreateLayoutFolderModal.vue?vue&type=template&id=bad3b68c&scoped=true", function () {
      api.rerender('bad3b68c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/CreateLayoutFolderModal.vue"
export default component.exports